import { useEffect, useRef } from "react";
import { track } from "@shared/lib/analytics-client";

/**
 * Émet un événement nommé au montage de la page.
 * Déposez <PageTracker event="landing_viewed" /> dans n'importe quelle page :
 * si la page est refondue, seul ce composant doit être conservé pour que les
 * métriques restent exactes.
 */
export function PageTracker({
  event,
  properties,
}: {
  event: string;
  properties?: Record<string, string | number | boolean | null>;
}) {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    track(event, properties);
    // Volontairement déclenché une seule fois par montage.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
